export default __webpack_public_path__ + "static/media/bannerbg.1d5f2501.png";